import * as Models from '../../../Models'
import * as Services from '../../../Services'

export interface ICancelCustomerScope extends ng.IScope {
  cancelCustomerCtrl: CancelCustomerController;
}

const internalSalePartnerCode = 'IGSSALES'

export class CancelCustomerController {
  public formSubmitted: boolean = false;
  public currentDate: number;
  public request: Models.Customer.CancelCustomerRequest.CancelCustomerRequest;
  public cancelReasonOptions: Models.Customer.CancelReason.ICancelReason[];
  public isInternalSale: boolean = false;

  public static $inject = ["$state", "$scope", "$modalInstance", "igsCustomerNumber", "CustomerApiClient"];

  constructor(
    public $state: angular.ui.IStateService,
    public $scope: ICancelCustomerScope,
    public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
    public igsCustomerNumber: string,
    private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
  ) {
    $scope.cancelCustomerCtrl = this;
    this.currentDate = Date.now();
    
    this.cancelReasonOptions = [];
    this.retrieveIsInternalSale();
    this.retrieveCancelReasons();

    this.request = new Models.Customer.CancelCustomerRequest.CancelCustomerRequest();
    this.request.igsCustomerNumber = this.igsCustomerNumber;
  }

  public submit = () => {
    this.customerApiClient.cancelCustomer(this.request).then(() => {
      this.$modalInstance.close(true);
    }),
      () => {
        toastr.error("There was an issue cancelling this customer. Please try again later.", "ERROR");
        this.formSubmitted = false;
      };
  };

  private retrieveIsInternalSale = async () => {
    let partner = await this.customerApiClient.getAllCustomerPartners(this.igsCustomerNumber)
    this.isInternalSale = partner.map(p => p.code).includes(internalSalePartnerCode)
  }

  private retrieveCancelReasons = async() => {
    let cancelReasons = await this.customerApiClient.getCancelReasons(false) 
    this.cancelReasonOptions = cancelReasons
  }

  public isFormValid = () => {
    let { cancellationDate, cancelReasonCode } = this.request;
    let requiresReasonCode = this.isInternalSale
    return !!cancellationDate && (!requiresReasonCode || !!cancelReasonCode);
  };

  public closeModal = () => {
    this.$modalInstance.close(false);
  };
}
